import { Form, Formik } from 'formik'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import SignatureCanvas from 'react-signature-canvas'
import * as Yup from 'yup'

import { Button } from 'Components/Form'
import { Breadcrumb } from 'Components/Layout/Header'
import { Cart } from 'Components/Ui'
import useAuth from 'Utils/Hooks/useAuth'

const validationSchema = Yup.object().shape({
    signature: Yup.string().required('The signature field is required.'),
})

export default function Signature() {
    const { signature } = useAuth()
    const { user } = useSelector(state => state.auth)
    const sigCanvas = useRef()

    useEffect(() => {
        if (user && sigCanvas.current) {
            sigCanvas.current.clear()
            if (user.signature) {
                sigCanvas.current.fromDataURL(user.signature, {
                    width: 500,
                    height: 200,
                })
            }
        }
    }, [user])

    if (!user) return null

    return (
        <>
            <Breadcrumb title="Signature" />
            <Cart title="Signature" className="xl:w-1/2">
                <Formik
                    initialValues={{
                        signature: user.signature,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={signature}
                >
                    {({ touched, errors, isSubmitting, setFieldValue }) => (
                        <Form className="flex flex-col gap-3">
                            <div>
                                <SignatureCanvas
                                    ref={sigCanvas}
                                    canvasProps={{
                                        width: 500,
                                        height: 200,
                                        className: 'border',
                                    }}
                                    onEnd={() => setFieldValue('signature', sigCanvas.current.toDataURL('image/png'))}
                                />
                                {touched.signature && errors.signature && (
                                    <p className="text-sm text-danger">{errors.signature}</p>
                                )}
                            </div>
                            <div className="flex items-center gap-3 mt-3">
                                <Button
                                    className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        sigCanvas.current.clear()
                                        setFieldValue('signature', null)
                                    }}
                                    type="button"
                                >
                                    Clear
                                </Button>
                                <Button
                                    className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    disabled={isSubmitting}
                                    type="submit"
                                >
                                    Save
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Cart>
        </>
    )
}
